import Vue from "vue/dist/vue.common";

export default {
    state: {
        personType: [],
        props: []
    },
    actions: {
    },
    mutations: {
        setActivePersonType(state, id) {
            state.personType = state.personType.map(personType => {
                Vue.set(personType, "CHECKED", (personType.ID === id) ? "Y" : "N");
                return personType;
            });
        },
        setActiveUserProfile(state, id) {
            const prop = state.props.find(prop => prop.code === "PROFILE_ID");
            if (prop && prop.value) {
                prop.value = prop.value.map(userProfile => {
                    Vue.set(userProfile, "checked", (userProfile.id === id) ? true : false);
                    return userProfile;
                });
            }
        },
        unselectUserProfiles(state) {
            const prop = state.props.find(prop => prop.code === "PROFILE_ID");
            if (prop && prop.value) {
                prop.value = prop.value.map(userProfile => {
                    userProfile.checked = false;
                    return userProfile;
                });
            }
        },
        setPersonType(state, personType) {
            state.personType = personType;
        },
        setProps(state, props) {
            state.props = props;
        },
        setPropValue(state, {value, code}) {
            const prop = state.props.find(prop => prop.code === code);
            prop.value = value;
        },
    },
    getters: {
        personTypes(state) {
            return state.personType;
        },
        activePersonType(state, getters) {
            return getters.personTypes.find((personType) => personType.CHECKED === "Y");
        },
        userProfiles(state) {
            const prop = state.props.find(prop => prop.code === "PROFILE_ID");
            if (prop) return prop.value;
        },
        activeUserProfile(state, getters) {
            return getters.userProfiles.find((userProfile) => userProfile.checked);
        }
    },
    namespaced: true
}